import { combineReducers } from 'redux';
import settings from './settings/reducer';
import menu from './menu/reducer';
import authUser from './auth/reducer';
import baseSetting from './settings/base_setting/reducer';
import profile from './settings/profile/reducer';
import mukeb from './mukeb/reducer';
import benefactor from './benefactor/reducer';
import users from './users/reducer';
import poll from './poll/reducer';
import axe from './axe/reducer';
import plate from './plate/reducer';

const reducers = combineReducers({
  menu,
  settings,
  authUser,
  baseSetting,
  profile,
  mukeb,
  benefactor,
  users,
  poll,
  axe,
  plate,
});

export default reducers;
